import { useEffect, useRef, useState } from 'react';

import Check from './assets/check.png';
import DoubleCheck from './assets/doublecheck.png';

import Button from '../../../../../../../components/bases/button/button';
import { isNativeInputKey } from '../../../../subtitles/common/functions';

export default function ReplaceForm({
  lang,
  showReplace,
  onReplaceOne,
  onReplaceAll,
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!showReplace) {
      setText('');
    }
  }, [showReplace]);

  function onKeyDown(event) {
    if (isNativeInputKey(event)) {
      event.stopPropagation();
      return;
    }
  }

  function onChange(event) {
    setText(event.target.value);
  }

  if (!showReplace) {
    return null;
  }

  return (
    <div className="replace-form">
      <label htmlFor="txtReplace" className="sr-only">
        {lang === 'fr' ? 'Remplacer' : 'Replace'}
      </label>
      <input
        id="txtReplace"
        type="text"
        placeholder={lang === 'fr' ? 'Remplacer' : 'Replace'}
        value={text}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />

      <Button
        id="btnReplace"
        tooltip={{
          fr: 'Remplacer',
          en: 'Replace',
        }}
        image={Check}
        width={16}
        height={16}
        onClick={() => onReplaceOne(text)}
      ></Button>
      <Button
        id="btnReplaceAll"
        tooltip={{
          fr: 'Tout remplacer',
          en: 'Replace all',
        }}
        image={DoubleCheck}
        width={16}
        height={16}
        onClick={() => onReplaceAll(text)}
      ></Button>
    </div>
  );
}
